import { c as _c } from "react/compiler-runtime";
import { forwardRef } from 'react';
import { preventDefault } from '../../utils';
import Select from './Select';
import type { SelectProps } from './types';
const ClientSelect = forwardRef<HTMLSelectElement, SelectProps>(function ClientSelect(t0, ref) {
  const $ = _c(9);
  let onChange_;
  let onClick_;
  let props;
  if ($[0] !== t0) {
    ({
      onChange: onChange_,
      onClick: onClick_,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = onChange_;
    $[2] = onClick_;
    $[3] = props;
  } else {
    onChange_ = $[1];
    onClick_ = $[2];
    props = $[3];
  }
  const {
    disabled
  } = props;
  const onChange = disabled ? preventDefault : onChange_;
  const onClick = disabled ? preventDefault : onClick_;
  let t1;
  if ($[4] !== onChange || $[5] !== onClick || $[6] !== props || $[7] !== ref) {
    t1 = <Select {...props} onChange={onChange} onClick={onClick} ref={ref} />;
    $[4] = onChange;
    $[5] = onClick;
    $[6] = props;
    $[7] = ref;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
});
export default ClientSelect;